(function(root,factory){
  if(root.CeikaVehicleReviews?.start){root.CeikaVehicleReviews.start();return;}
  const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;
  else{root.CeikaVehicleReviews=api;api.start();}
})(typeof globalThis!=='undefined'?globalThis:this,function(){
 'use strict';
 const words=()=>JSON.parse(document.querySelector('[data-ceika-review-labels]')?.textContent||'{}');
 const norm=s=>String(s||'').toLowerCase().normalize('NFKD').replace(/[^a-z0-9]/g,'');
 function tier(review,target,profiles,sourceId){
  if(review.sourceProductId===sourceId)return 0;
  const v=profiles[review.sourceProductId];if(!v||!target||v.family!==target.family||norm(v.make)!==norm(target.make))return 9;
  if(norm(v.model)&&norm(v.model)===norm(target.model)){
   if(norm(v.chassis)&&norm(v.chassis)===norm(target.chassis)&&norm(v.years)&&norm(v.years)===norm(target.years))return 0;
   return 1;
  }return 2;
 }
 function rank(data,sourceId,family){
  const target=data.profiles[sourceId];if(!target||target.family!==family)return [];
  const seen=new Set();
  return data.reviews.filter(r=>r.family===family&&r.excerpt&&r.rating>=1&&r.rating<=5&&!seen.has(r.id)&&seen.add(r.id))
   .map(r=>({...r,tier:tier(r,target,data.profiles,sourceId)})).filter(r=>r.tier<3)
   .sort((a,b)=>a.tier-b.tier||(Date.parse(b.date)||0)-(Date.parse(a.date)||0)||a.id.localeCompare(b.id));
 }
 const requests=new Map();
 function json(url){
  if(!requests.has(url)){
   const controller=new AbortController();
   const timer=setTimeout(()=>controller.abort(),12000);
   const request=fetch(url,{credentials:'omit',signal:controller.signal}).then(r=>{if(!r.ok)throw Error('Review source unavailable');return r.json();}).catch(error=>{requests.delete(url);throw error;}).finally(()=>clearTimeout(timer));
   requests.set(url,request);
  }
  return requests.get(url);
 }
 function el(tag,cls,text){const n=document.createElement(tag);if(cls)n.className=cls;if(text!=null)n.textContent=String(text);return n;}
 function publishedNodes(html,data){
  const doc=new DOMParser().parseFromString(html,'text/html'),out=[];
  doc.querySelectorAll('.jdgm-rev[data-review-id]').forEach(n=>{
   let handle;try{const u=new URL(n.getAttribute('data-product-url')||'');if(!['ceika-store.com','ceika-performance-store.myshopify.com','ceikaperformance.fr'].includes(u.hostname))return;handle=decodeURIComponent(u.pathname.split('/products/')[1]||'').split('/')[0];}catch(e){return;}
   const pid=data.handles[handle];if(!pid)return;
   const text=cls=>(n.querySelector(cls)?.textContent||'').replace(/\s+/g,' ').trim();
   const rating=Number(n.querySelector('.jdgm-rev__rating')?.getAttribute('data-score'));
   out.push({id:n.getAttribute('data-review-id'),family:data.profiles[pid].family,sourceProductId:pid,rating,date:n.querySelector('time')?.getAttribute('datetime')||'',author:text('.jdgm-rev__author'),title:text('.jdgm-rev__title'),excerpt:text('.jdgm-rev__body').slice(0,300),productTitle:n.getAttribute('data-product-title')||'',verified:n.getAttribute('data-verified-buyer')==='true'});
  });return out;
 }
 async function updatePublished(data,sourceId){
  const all=new Map(data.reviews.map(r=>[r.id,r]));
  for(let page=1;page<=3;page++){
   const u=new URL('https://cdn.judge.me/reviews/reviews_for_widget');
   u.search=new URLSearchParams({shop_domain:'ceika-performance-store.myshopify.com',url:'ceika-performance-store.myshopify.com',platform:'shopify',product_id:sourceId,per_page:'20',page:String(page),ts:String(Math.floor(Date.now()/3600000))});
   const reply=await json(u.href);if(typeof reply.html!=='string')throw Error('Invalid review feed');
   const doc=new DOMParser().parseFromString(reply.html,'text/html');
   const dates=[...doc.querySelectorAll('.jdgm-rev time[datetime]')].map(n=>Date.parse(n.getAttribute('datetime'))).filter(Number.isFinite);
   publishedNodes(reply.html,data).forEach(r=>all.set(r.id,r));
   data={...data,reviews:[...all.values()]};
   if(!dates.length||Math.min(...dates)<=Date.parse(data.capturedAt)||!doc.querySelector('[data-page]'))return {...data,capturedAt:new Date().toISOString(),liveChecked:true};
  }return data;
 }
 function start(scope=document){
  if(typeof document==='undefined')return;
  if(!document.documentElement.dataset.ceikaReviewNavigation){
   document.documentElement.dataset.ceikaReviewNavigation='true';
   document.addEventListener('click',event=>{
    if(!event.target.closest?.('.coil-review-badge,.ceika-product-pilot__reviews'))return;
    const section=document.querySelector('[data-ceika-owner-reviews]');if(!section)return;
    event.preventDefault();event.stopImmediatePropagation();section.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
   },true);
  }
  const hosts=[...(scope.matches?.('[data-ceika-owner-reviews]')?[scope]:[]),...scope.querySelectorAll('[data-ceika-owner-reviews]')];
  hosts.forEach(host=>{
   if(host.dataset.reviewReady)return;host.dataset.reviewReady='true';
   const load=async()=>{
    const status=host.querySelector('[data-review-status]'),cards=host.querySelector('[data-review-cards]');
    if(!status||!cards){delete host.dataset.reviewReady;return;}
    status.textContent=host.dataset.reviewLoading||'Checking highlights for this vehicle…';
    host.setAttribute('aria-busy','true');
    const watchdog=setTimeout(()=>{status.textContent=host.dataset.reviewWaiting||'Vehicle highlights are taking longer than expected. Browse the full review feed below.';host.setAttribute('aria-busy','false');},13000);
    try{
     const index=await json(host.dataset.reviewIndex),key=index.products[host.dataset.sourceId];
     if(!key||!/^[a-z0-9-]+$/.test(key))throw Error('Vehicle mapping unavailable');
     let data=await json(host.dataset.reviewAssetPattern.replace('REVIEWKEY',key));
     const render=data=>{if(!host.isConnected)return;cards.replaceChildren();
     const ranked=rank(data,host.dataset.sourceId,host.dataset.family),items=ranked.slice(0,3);
     const target=data.profiles[host.dataset.sourceId];
     status.textContent=items.length?(host.dataset.reviewHighlights||'Owner experiences for your vehicle and brand.'):(host.dataset.reviewEmpty||'Explore owner experiences from across the CEIKA range below.');
     items.forEach(r=>{
      const article=el('article','ceika-owner-reviews__card');
      article.dataset.reviewId=r.id;article.dataset.matchTier=String(r.tier);
      const relevance=el('span','ceika-owner-reviews__match',r.tier===0?words().same_generation:r.tier===1?words().same_model:words().same_brand.replace('[brand]',target.make));
      const meta=el('div','ceika-owner-reviews__meta'),stars=el('span','ceika-owner-reviews__stars','★'.repeat(r.rating)+'☆'.repeat(5-r.rating));
      stars.setAttribute('aria-label',r.rating+' out of 5 stars');stars.setAttribute('role','img');meta.append(stars);
      if(Number.isFinite(Date.parse(r.date))){const date=el('time','',new Date(r.date).toLocaleDateString(document.documentElement.lang||'en',{day:'numeric',month:'short',year:'numeric'}));date.dateTime=r.date;meta.append(date);}
      const quote=el('blockquote','',r.excerpt.slice(0,180)+(r.excerpt.length>=180?'…':''));
      const author=el('p','ceika-owner-reviews__author',r.author||words().customer);if(r.verified)author.append(el('span','','✓ '+words().verified));
      article.append(relevance,meta,quote,author,el('p','ceika-owner-reviews__vehicle',r.productTitle),el('small','',words().excerpt));
      cards.append(article);
     });
     };
     render(data);
     updatePublished(data,host.dataset.sourceId).then(updated=>{host.dataset.reviewRefresh=updated.liveChecked?'live':'bounded';render(updated);}).catch(()=>{host.dataset.reviewRefresh='snapshot';});
    }catch(error){status.textContent=host.dataset.reviewUnavailable||'Vehicle highlights are temporarily unavailable. The full Judge.me review feed remains below.';host.dataset.reviewRefresh='unavailable';}
    finally{clearTimeout(watchdog);host.setAttribute('aria-busy','false');}
   };
   if('IntersectionObserver'in window){const obs=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){obs.disconnect();load();}},{rootMargin:'250px'});obs.observe(host);}else load();
  });
 }
 if(typeof document!=='undefined'){
  document.addEventListener('DOMContentLoaded',()=>start());
  document.addEventListener('shopify:section:load',event=>start(event.target));
 }
 return{tier,rank,start};
});

